module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAC0AAAAmBAMAAACi8w9qAAAAAXNSR0IB2cksfwAAABhQTFRFAAAA////////////////////////////I36dXwAAAAh0Uk5TAAgYeDCAUCAy5KmDAAAAjklEQVR4nK2QuQ2AMBAEAVlyIdRATuIOMLH7r4LPz3m8IReOZqTTThNuJsi37hIv26H1GFWwbDGq4NZV8OgqePUx+PQxyDqDojOoOoLQeLLcVXxmMiMoeh7RQa8jBujlAQe9fhyg28DqNuj0FvR6C6CXwEP/f0QGqecckUEid1rHiAiE3o2IQOpmRJwfyAXtq1sdshJknwAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/mpd-library/assets/side-menu-reports@2x.png
// module id = 956
// module chunks = 0